import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
const maxDots = 5;
export const FlavorFinderResultCardSpec = ({ power, label }) => {
    return (_jsxs("div", { className: "flavorfinder__result-card-spec", children: [_jsx("span", { className: "spec__title", children: label }), _jsx("div", { className: "spec__power", children: _jsxs("div", { className: "spec__scale", children: [[...Array(maxDots).keys()].map((item) => {
                            const isFullActive = item < Math.floor(power);
                            const isHalfActive = power - item > 0 && power - item < 1;
                            return (_jsx("span", { className: classNames("spec__dot", {
                                    "spec__dot--active": isFullActive,
                                    "spec__dot--half": isHalfActive,
                                }) }, item));
                        }), _jsx("span", { className: "spec__value", children: power })] }) })] }));
};
export default FlavorFinderResultCardSpec;
//# sourceMappingURL=FlavorFinderResultsCardSpec.js.map